import FrontendService from '../api/frontendService';
import {WrapperAppSalesDemos} from '../api/frontendService/entities';

import {Thunk} from './redux-thunk';

//#region Actions

enum ActionType {
  SalesDemosLoadingStart = 'SalesDemosLoadingStart',
  SalesDemosLoadingSuccess = 'SalesDemosLoadingSuccess',
  SalesDemosLoadingError = 'SalesDemosLoadingError'
}

const buildLoadingStartAction = () => ({
  type: ActionType.SalesDemosLoadingStart as typeof ActionType.SalesDemosLoadingStart
});

const buildLoadingSuccessAction = (salesDemosResponse: WrapperAppSalesDemos) => ({
  type: ActionType.SalesDemosLoadingSuccess as typeof ActionType.SalesDemosLoadingSuccess,
  salesDemosResponse
});

const buildLoadingErrorAction = () => ({
  type: ActionType.SalesDemosLoadingError as typeof ActionType.SalesDemosLoadingError
});

type Action =
  | ReturnType<typeof buildLoadingStartAction>
  | ReturnType<typeof buildLoadingSuccessAction>
  | ReturnType<typeof buildLoadingErrorAction>;

export const loadSalesDemos = (): Thunk => async (dispatch, getState) => {
  dispatch(buildLoadingStartAction());

  const {apiKey} = getState().authentication.account;
  try {
    const response = await FrontendService.fetchSalesDemos(apiKey);
    dispatch(buildLoadingSuccessAction(response));
  } catch (e) {
    dispatch(buildLoadingErrorAction());
  }
};

//#endregion

//#region State

export enum LoadingState {
  Default = 'Default',
  Loading = 'Loading',
  Success = 'Success',
  Error = 'Error'
}

export interface State {
  readonly loadingState: LoadingState;
  readonly response: WrapperAppSalesDemos;
}

const defaultState: State = {
  loadingState: LoadingState.Default,
  response: undefined
};

//#endregion

export const reducer = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case ActionType.SalesDemosLoadingStart:
      return {
        ...state,
        loadingState: LoadingState.Loading
      };

    case ActionType.SalesDemosLoadingSuccess:
      return {
        ...state,
        loadingState: LoadingState.Success,
        response: action.salesDemosResponse
      };

    case ActionType.SalesDemosLoadingError:
      return {
        ...state,
        loadingState: LoadingState.Error,
        response: undefined
      };

    default:
      return state;
  }
};
